import {Component, OnDestroy, OnInit} from '@angular/core';
import {PharmacyService} from '../../services/pharmacy/pharmacy.service';
import {Subject, takeUntil} from 'rxjs';
import {iResponse, iResponseList} from '../../models/response/response.model';
import {PharmacyModel} from '../../models/pharmacy/pharmacy.model';
import {CdkAccordion, CdkAccordionItem} from '@angular/cdk/accordion';
import { NgClass} from '@angular/common';
import {PharmacyCreateComponent} from '../pharmacy-create/pharmacy-create.component';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-pharmacy-administration',
    imports: [
        CdkAccordion,
        CdkAccordionItem,
        NgClass,
        PharmacyCreateComponent,
    ],
  templateUrl: './pharmacy-administration.component.html',
  styleUrl: './pharmacy-administration.component.sass'
})
export class PharmacyAdministrationComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    pharmacies: PharmacyModel[] = [];
    isPharmacyCreate: boolean = false;
    pharmacyEditId: string = '';

    constructor(
        private pharmacyService: PharmacyService,
        private dialog: MatDialog
    ) {
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit() {
        this.getPharmacies();
    }

    triggerReload(triggered: boolean) {
        this.getPharmacies();
    }

    triggerPharmacyCreate(triggered: boolean): void {
        this.isPharmacyCreate = !this.isPharmacyCreate;
    }

    triggerPharmacyEdit(id: string): void {
        if (this.pharmacyEditId === id) {
            this.pharmacyEditId = '';
            this.getPharmacies();
        } else {
            this.pharmacyEditId = id;
        }
    }

    openConfirmModal(id: string): void {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            closeOnNavigation: true,
            disableClose: true,
            data: {text:'Soll die Praxis wirklich gelöscht werden ?', header: 'Löschen', delete:true}
        })

        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                this.deletePharmacy(id);
            }
        })
    }

    private getPharmacies(): void {
        this.pharmacyService.getPharmacies()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponseList<PharmacyModel>) => {
                    this.pharmacies = response.data;
                },
                error: (error) => {
                }
            })
    }

    private updatePharmacy(pharmacy: PharmacyModel): void {
        this.pharmacyService.updatePharmacy(pharmacy)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponse<PharmacyModel>) => {
                },
                error: (error) => {
                }
            })
    }

    private deletePharmacy(id: string): void {
        this.pharmacyService.deletePharmacy(id)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (response: iResponse<boolean>) => {
                },
                error: (error) => {
                }
            })
    }
}
